export default __webpack_public_path__ + "static/media/coins.3c89e3a8.svg";